import React from 'react';
import Placeholder from './interactions/Placeholder';
import Pager from './interactions/Pager';
import Accordion from './interactions/Accordion';
import Carousel from './interactions/Carousel';
import SingleSelect from './interactions/SingleSelect';
import ClickReveal from './interactions/ClickReveal';
import DragAndDrop from './models/FinalDragDrop/DragAndDrop';
import Quiz from './models/Quiz';
import Trip from './models/Trip/Trip';
import WalkingSim from './models/orientation/WalkingSim';
// import FinalDragDrop from './models/FinalDragDrop/FinalDragDrop';
import FinalDragDrop from './models/DnD/FinalDragDrop'


import DriversReport from './models/DriversReport';
import DynamicPager from './models/DynamicPager';
import Conclusion from './models/Conclusion';
import RouteSelection from './models/RouteSelection';
import HelensDiner from './models/HelensDiner';
import Survey from './models/Survey/Survey';

//customs


export default (type, props) => {
  //boilerplate
  if (type.toLowerCase() === "pager") {
    return <Pager {...props}/>
  }
  if (type.toLowerCase() === "accordion") {
    return <Accordion {...props}/>
  }
  if (type.toLowerCase() === "carousel") {
    return <Carousel {...props}/>
  }
  if (type.toLowerCase() === "singleselect") {
    return <SingleSelect {...props}/>
  }
  if (type.toLowerCase() === "quiz") {
    return <Quiz {...props}/>
  }
  if (type.toLowerCase() === "draganddrop") {
    return <DragAndDrop {...props}/>
  }
  if (type.toLowerCase() === "clickreveal") {
    return <ClickReveal {...props}/>
  }

  //customs
  if (type.toLowerCase() === "trip") {
    return <Trip {...props}/>
  }
  if (type.toLowerCase() === "walking-sim"){
    return <WalkingSim {...props} />
  }
  if(type.toLowerCase() === 'final-drag-drop'){
    return <FinalDragDrop {...props} />
  }
  if(type.toLowerCase() === 'drivers-report'){
    return <DriversReport {...props} />
  }
  if(type.toLowerCase() === 'dynamic-pager'){
    return <DynamicPager {...props } />
  }
  if(type.toLowerCase() === 'conclusion'){
    return <Conclusion {...props } />
  }
  if(type.toLowerCase() === 'route-selection'){
    return <RouteSelection {...props } />
  }
  if(type.toLowerCase() === 'helens-diner'){
    return <HelensDiner {...props} />
  }
  if(type.toLowerCase() === 'survey'){
    return <Survey {...props} />
  }

  //component doesn't exist yet
  return <Placeholder type={type} {...props}/>

}